<div [class]="classes" [style]="style">
  <ng-content></ng-content>
</div>
